import { useEffect } from "react";

function Game({ id = null }) {
  const scriptId = `keesing-script`

  useEffect(() => {
    // Add the braintainment script.
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement("script");
      document.body.appendChild(script);
    }
    script.id = scriptId;
    script.src = "https://web.braintainment.com/pub/bundle-loader/bundle-loader.js";
    script.setAttribute(`data-wlpp-bundle`, id ? "player" : "portal");
    script.type = "text/javascript";
    script.async = true;

    // Remove the script when the component unloads.
    return () => {
      const scriptElement = document.getElementById(scriptId);
      if (scriptElement) {
        scriptElement.remove();
      }
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []
 );

  return (
    <>
      <link rel="stylesheet" href="https://web.braintainment.com/pub/config/anbotrefpunt/css/custom_client.css"/>
      <div id="puzzle-portal"
           data-customerid="anbotrefpunt"
           data-playerpath="/doe-mee/spelletjes"
           data-game-type={ id }
           data-puzzleid={ id && `${ id }_today` }>
      </div>
    </>
  )
}

export default Game;
